import { AfterViewInit, Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { GlobalServices } from '../global.services';
import { Meta, Title } from '@angular/platform-browser';
declare var hbspt: any;
declare var $: any;

@Component({
  selector: 'app-corporate',
  templateUrl: './corporate.component.html',
  styleUrls: ['./corporate.component.scss']
})
export class CorporateComponent implements OnInit, AfterViewInit {
  public showAlert: boolean = false;
  public responseMessage: string = "";
  public submitted: boolean = false;
  emailForm: FormGroup;
  constructor(public globalServices: GlobalServices, public fb: FormBuilder, public viewContainerRef: ViewContainerRef, public cfr: ComponentFactoryResolver, public httpService: ApiService, public metatitle: Title, public meta: Meta) {
    this.emailForm = this.fb.group({
      email: [null, [Validators.required, checkValidatePssword.bind(this)]]
    });

    function checkValidatePssword(controls: AbstractControl): { passwordCheck: boolean } {
      let password = controls.value;
      if (password) {
        if ((password.indexOf('@') > -1) && (password.indexOf('.') > -1) && (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(password))) {
          return null;
        } else {
          return { passwordCheck: true };
        }
      }
      return null;
    }

    if (this.globalServices.isBrowser) {
      this.metatitle.setTitle('Corporate Wellness Programs - MyWorkWell from MyLifeWell');
      this.meta.updateTag({
        name: 'description',
        content: "Bring wellness to your workplace with MyWorkWell's corporate wellness programs. Explore our comprehensive company wellness solutions for keeping your employees happy and healthy."
      });
      this.meta.updateTag({
        name: 'keywords',
        content: 'corporate wellness programs, workplace wellness programs, company wellness programs, employee health and wellness programs, best corporate wellness programs, corporate health and wellness programs, corporate health programs'
      });
    }
  }
  get f() { return this.emailForm.controls; }

  ngOnInit(): void {
    if (this.globalServices.isBrowser) {
      this.globalServices?.hideHeader.next(false);
      this.globalServices?.hideFooter.next(false);
      this.globalServices.headerviewcontainerhelper = this.viewContainerRef;
      this.globalServices.headercrf = this.cfr;
    }
  }

  ngAfterViewInit() {
    hbspt.forms.create({
      portalId: '8304524',
      formId: 'eea979e4-bfa6-4902-89db-d1edc0585119',
      target: '#form-target',
      locale: 'en',
      inlineMessage: "Thank you for your interest in partnering with MyLifeWell. Our team will review your application and be in touch within 3-5 business days.",
    });
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  submit() {
    this.submitted = true;
    if (this.emailForm.valid) {
      let urlSubscribe = "global/newsletter";
      let data = { email: this.emailForm.value.email };
      this.httpService.postFormData(urlSubscribe, data).subscribe(res => {
        this.showAlert = true;
        this.responseMessage = res.message;
        if (this.globalServices.isBrowser) {
          setTimeout(() => {
            this.submitted = false;
            this.showAlert = true;
            this.responseMessage = ' ';
          }, 2000);
          this.emailForm.reset();
        }
      });
    } else {
      return;
    }
  }
  opensignupmodal() {
    this.globalServices.viewcontainerhelper = this.viewContainerRef;
    this.globalServices.triggersignup(this.viewContainerRef, this.cfr);
  }
  scrolltoform() {
    if (this.globalServices.isBrowser) {
      $('html, body').animate({
        scrollTop: $('#enquiry_form_hubspot').offset().top
      }, 2000);
    }
  }

}
